import { Utils } from '@genial/utils';
import * as zod from 'zod';

export type PrivatePensionApplicationFormData = {
  value: string;
  clientEmail: string;
  advisorEmail: string;
};

export const getDefaultValues = (minValue: number) => ({
  value: minValue,
  clientEmail: '',
  advisorEmail: '',
});

export type PrivatePensionApplicationData = ReturnType<typeof getDefaultValues>;

export const getValidationCreateSchema = (minValue: number, maxValue: number) =>
  zod
    .object({
      value: zod.string(),
      clientEmail: zod.string(),
      advisorEmail: zod.string().optional(),
    })
    .refine((data) => Utils.Unmask.Money(data.value) >= minValue, {
      path: ['value'],
      message: `O valor do saque deve ser maior que ${Utils.Mask.Money(minValue)}.`,
    })
    .refine((data) => Utils.Unmask.Money(data.value) < maxValue, {
      path: ['value'],
      message: `O valor do saque deve ser maior que ${Utils.Mask.Money(maxValue)}.`,
    })
    .refine((data) => !!data.clientEmail, {
      path: ['clientEmail'],
      message: 'O e-mail do cliente é obrigatório.',
    });
